import { decode } from 'he';

export const htmlToText = (html) => decode(html
  .replace(/<\/p>/g, '\n\n')
  .replace(/<ul>/g, '\n')
  .replace(/<\/ul>/g, '\n')
  .replace(/<ol>/g, '\n')
  .replace(/<\/ol>/g, '\n')
  .replace(/<li>/g, '\n')
  .replace(/<\/li>/g, '\n')
  .replace(/<\/h\d>/g, '\n\n')
  .replace(/<[^>]*>/g, ''));

export const isEmptyHtml = (html) => htmlToText(html).trim().length === 0;
